goog.provide('el8.appchart.visitNote.section');

goog.require('el8.appchart.visitNote.textarea');
goog.require('el8.appchart.visitNote.textlist');
goog.require('el8.appchart.visitNote.textlisteditor');
goog.require('el8.appchart.visitNote.textmultilist');
goog.require('el8.template.appchart.visitNote');
goog.require('el8.template.appchart.visitNote.oneCol');
goog.require('el8.template.appchart.visitNote.twoCol');
goog.require('el8.util.base');
goog.require('el8.util.string');


el8.appchart.visitNote.section = function(spec) {

    this._originalSpec = spec;
    this._note = spec.note;
    this._form = spec.form;  // el8.uiwidget.Form
    this._name = spec.name;  // expected to be one word
    this._infoText = spec.infoText;
    this._type = spec.type || null;
    this._templateClass = spec.templateClass || null;

    this._isHidden = (spec.isHidden === true); // defaults to false
    this._showTrigger = null;

    this._mindreaderOpts = spec.mindreaderOpts || null;
    this._listeditorOpts = spec.listeditorOpts || null;
    this._multilistOpts = spec.multilistOpts || null;
    this._textareaOpts = spec.textareaOpts || null;

    this._sectionSelector = spec.sectionSelector || null;

    this._container = null;
    this._widget = null;
    this._infoField = null;

    this._referencedItems = {};
    this._isShown = false;
};

el8.appchart.visitNote.section.prototype.create = function() {

    var type = this._type;
    var fieldSpec = {
        name: this._originalSpec.name,
        maxLength: this._originalSpec.maxLength,
        infoText: this._originalSpec.infoText,
        defaultVal: this._originalSpec.defaultVal,
        height: this._originalSpec.height,
        // used for when handling VisitNoteTemplate edit/create view
        isVisitNoteTemplate: this._originalSpec.isVisitNoteTemplate,
        type: type
    };
    fieldSpec.tmplFn = el8.template.appchart.visitNote[this._templateClass]['field'+this._name.capitalize()];
    fieldSpec.tmplStubSelector = '#visit-note-stub-'+this._name;

    this._infoField = null;
    if (type !== 'textlist') {
        this._form.addField(fieldSpec);
        this._infoField = this._form.getInfoField(this._name);
    } else {
        $(fieldSpec.tmplStubSelector, this._form.getContainer())
            .replaceWith(fieldSpec.tmplFn(fieldSpec));
    }

    var category = this._name.capitalize();
    var note = this._note;

    /* Note that this saveFn is only used for textarea, listeditor, multilist,
     * and not for textlist (or textlist part of textlisteditor, or textlist
     * part of textmultilist).*/
    var saveFn = function(id, val, index, opts) {
        var set = note.getBulletSets()[category];
        var item = id ? set.getById(id) : set.create({});
        item.setEditId(note.getCurrentEditId());
        val = el8.util.string.cleanMultiByteChars(val); // remove emoji
        item.setText(val);

        /* For bullets that can accommodate text (i.e. not in textlist widget),
         * we consider deleting all the text (saving blank bullet) as a request
         * for any document reference to be deleted as well. Worth nothing that
         * listeditor and multilist don't allow saving of empty bullets - the
         * bullet gets deleted instead */
        if (!item.getText()) {
            item.setDocumentId(null);
        }

        item.setSequence(index);
        var jqXhr = set.saveItem(item, false, opts);
        return jqXhr; // return the XHR so we can use it a Promise
    };
    var removeFn = function(id, opts) {
        var set = note.getBulletSets()[category];
        var item = set.getById(id);
        if (item) {
            var newOpts = Object.assign({}, opts)
            newOpts.successCb = function() {
                if (opts && typeof opts.successCb == "function") {
                    opts.successCb()
                }

                if (el8Globals.FEATURES.AutoImportBilling) {
                    var isRemoveFromAssessmentOrPlan = ['Assessment', 'Assessplan'].includes(category);
                    var isBulletWithDx = item.getModelClass() === PATIENT_MODEL_CLASSES.VISIT_NOTE_BULLET && item.getImoIds().length > 0;
                    if (isRemoveFromAssessmentOrPlan && isBulletWithDx) {

                        // Collect set of ICD-10 codes to remove directly from VNB
                        var codes = item.getIcd10Codes();
                        var removeDxs = codes.slice();

                        // Exclude ICD-10 codes still associated to remaining assessments
                        var bullets = set._all;
                        bullets.forEach(function (bullet) {
                            var remainingDxs = bullet.getIcd10Codes();
                            remainingDxs.forEach(function (code) {
                                if (!removeDxs.includes(code)) { return; }
                                removeDxs = removeDxs.filter(function (dx) {
                                    return dx !== code
                                });
                            });
                        });

                        if (removeDxs.length > 0) {
                            el8.appchart.visitNote.main.removeBillingDiagnoses({icd10Codes: removeDxs});
                        }
                    }
                }
            }

            item.setEditId(note.getCurrentEditId());
            set.deleteItem(item, false, newOpts);
        }
    };

    switch(type) {

        case 'listeditor':
        case 'textlisteditor':
            var opts = {
                editFriendly: true,
                list: $('#visit-note-list-'+this._name, this._form.getContainer()),
                getItemIdFn: function(item) { return item.getId(); },
                getItemTextFn: function(item) { return item.getText(); },
                saveFn: saveFn,
                removeFn: removeFn,
                mindreaderOpts: this._mindreaderOpts
            };
            if (this._listeditorOpts) {
                $.extend(opts, this._listeditorOpts);
            }
            if (type === 'listeditor') {
                this._widget = new el8.uiwidget.listeditor(opts).init(this._infoField);

            } else if (type === 'textlisteditor') {
                $.extend(opts, {
                    textlistOpts: {
                        list: $('#visit-note-owned-list-'+this._name, this._form.getContainer()),
                        isEdit: this._note.getCurrentEditId(),
                        set: note.getBulletSets()[category],
                        removeFn: removeFn,
                        note: note
                    }
                });
                this._widget = new el8.appchart.visitNote.textlisteditor(opts).init(this._infoField);
            }
            break;

        case 'multilist':
        case 'textmultilist':
            var opts = {
                list: $('#visit-note-list-'+this._name, this._form.getContainer()),
                getItemIdFn: function(item) { return item.getId(); },
                getItemTextFn: function(item) { return item.getText(); },
                getChildrenFn: function(item) {
                    return item.getChildrenSet().sorted();
                },
                parentRemoveFn: removeFn,
                genChildRemoveFn: function(parentId) {
                    var parentSet = note.getBulletSets()[category].getById(parentId);
                    return function(id) {
                        var set = parentSet.getChildrenSet();
                        var item = set.getById(id);
                        if (item) {
                            item.setEditId(note.getCurrentEditId());
                            set.deleteItem(item);
                        }
                    };
                },
                parentSaveFn: saveFn,
                genChildSaveFn: function(parentId) {
                    var parentSet = note.getBulletSets()[category].getById(parentId);
                    return function(id, val, index, opts) {
                        var set = parentSet.getChildrenSet();
                        var item = id ? set.getById(id) : set.create({});
                        item.setEditId(note.getCurrentEditId());
                        item.setParentId(parentId);
                        item.setText(val);
                        item.setSequence(index);
                        set.saveItem(item, false, opts);
                    };
                },
                isSortable: Boolean(!note.getCurrentEditId()), // true if note is NOT being edited
                sortSaveFn: function(ids) {
                    for (var i=0; i<ids.length; i++) {
                        var bullet = note.getBulletSets()[category].getById(ids[i]);
                        bullet.setSequence(i);
                    }
                    if (note.getModelClass() === 'VisitNoteTemplate') {
                        // we don't record bullet reordering to server for VNT
                        return;
                    }
                    $.el8_ajax({
                        type: 'POST',
                        url: el8.service.urls.get('reorderVisitNoteBullets', [note.getId()]),
                        data: {'data': JSON.stringify({'bullet_ids': ids})}
                    });
                }
                //mindreaderOpts: this._mindreaderOpts // TODO disabled mindreader for now on multilist
            };
            if (this._multilistOpts) {
                $.extend(opts, this._multilistOpts);
            }
            if (type === 'multilist') {
                this._widget = new el8.uiwidget.multilist(opts).init(this._infoField);

            } else if (type === 'textmultilist') {
                $.extend(opts, {
                    textlistOpts: {
                        list: $('#visit-note-owned-list-'+this._name, this._form.getContainer()),
                        isEdit: this._note.getCurrentEditId(),
                        set: note.getBulletSets()[category],
                        removeFn: removeFn,
                        note: note
                    }
                });
                this._widget = new el8.appchart.visitNote.textmultilist(opts).init(this._infoField);
            }
            break;

        case 'textarea':
            var opts = {
                saveFn: saveFn,
                removeFn: removeFn,
                form: this._form
            };
            if (this._textareaOpts) {
                $.extend(opts, this._textareaOpts);
            }
            this._widget = new el8.appchart.visitNote.textarea(opts).init(this._infoField);
            var inputField = this._infoField.getInputField();
            if (this._mindreaderOpts && inputField.is('input')) {  // no autocomplete for textareas
                var opts = $.extend({}, this._mindreaderOpts);
                (new el8.uiwidget.LegacyMindreader(opts)).init(inputField);
            }
            break;

        case 'textlist':
            var opts = {
                list: $('#visit-note-list-'+this._name, this._form.getContainer()),
                removeFn: removeFn,
                isEdit: this._note.getCurrentEditId(),
                set: note.getBulletSets()[category],
                note: note,
                sectionElt: this._sectionSelector ?
                    $(this._sectionSelector, this._form.getContainer()) : null
            };
            this._widget = new el8.appchart.visitNote.textlist(opts).init();
            break;

        default:
            break;
    }

    if (type !== 'textlist') {
        this._container = this._infoField.getInputField().closest('.visit-note-section');
        if (this._isHidden) {
            // Any section that is isHidden=true will initialize as hidden
            // Add a trigger
            this._showTrigger = $(
                el8.template.appchart.visitNote.sectionTrigger({
                    name: this._name,
                    label: '+ Add '+this._name
                })
            );
            this._container.before(this._showTrigger);
            this.hide();
        }
    } else {
        this._container = $('#visit-note-list-'+this._name, this._form.getContainer()).closest('.visit-note-section');
    }

    return this;
};

el8.appchart.visitNote.section.prototype.addEntry = function(item, doHighlight, opts) {
    if (!this._widget) { return; }
    var that = this;
    opts = opts || {};

    this.show();

    if (item.getRefId()) {
        this._referencedItems[item.getRefId()] = item;
    }
    item.setEditId(this._note.getCurrentEditId());

    if (this._type === 'textarea') {
        // textarea.addEntry will take care of saving itself even if we're ID-less
        this._widget.addEntry(item, opts.successCb);

    } else if (this._type === 'textlist' ||
        ( (this._type === 'textlisteditor' || this._type === 'textmultilist') &&
           item.isDocumentOwnedBy()) ) {

        this._widget.addEntry(item, doHighlight);
        // Note: we're assuming that it's ok to call successCb without waiting for any
        // saves inside addEntry. addEntry usually adds DOM elements before any internal
        // saves are complete, so that should be ok it's but worth noting that assumption.
        if (opts.successCb) { opts.successCb(); }

    } else {  // textlisteditor/listeditor bullet, textmultilist/multilist bullet

        // Make sure item has ID before adding to widget
        // (Note: these widgets could probably be made to fend for themselves here
        //  and some of them probably already do, but it's tough to audit them all)
        if (!item.getId()) {
            // We're just appending to the end of the list. Don't provide an explicit sequence,
            // because the server will know what index that transaltes to better than us.
            item.setSequence(null);

            this._note.getBulletSets()[item.getCategory()].saveItem(
                item,
                false,
                {
                    async: opts.async, // defaults true
                    successCb: function() {
                        // We'll use this wrapper for the widget's .addEntry fn (if it exists)
                        // to prevent it from becoming dirty here. Otherwise a save-as-draft
                        // would incorrectly want to save much more than is correct.
                        // Other callers can also use them if this situation arises for them.
                        if (that._widget.addEntryAsClean) {
                            that._widget.addEntryAsClean(item, doHighlight);
                        } else {
                            that._widget.addEntry(item, doHighlight);
                        }

                        if (opts.successCb) { opts.successCb(); }
                    }
                }
            );
        } else {
            if (that._widget.addEntryAsClean) {
                that._widget.addEntryAsClean(item, doHighlight);
            } else {
                that._widget.addEntry(item, doHighlight);
            }
            if (opts.successCb) { opts.successCb(); }
        }

    }

};

el8.appchart.visitNote.section.prototype.addEntries = function(items, doHighlight) {
    if (!this._widget) { return; }
    for (var i=0; i<items.length; i++) {
        this.addEntry(items[i], doHighlight);
    }
};

el8.appchart.visitNote.section.prototype.addEntryChild = function(index, childItem, doHighlight) {
    if (!this._widget || !this.isMultilist()) { return; }
    var that = this;

    this._referencedItems[childItem.getRefId()] = childItem;

    index = !el8.util.isNone(index) ? index : this._widget.numEntries() - 1; // default is to get the last bullet
    if (index < 0) { index = 0; }
    var entry = this._widget.getNthEntry(index);

    if (!childItem.getId()) {
        var category = childItem.getCategory();
        var _parent = this._note.getBulletSets()[category].getById(childItem.getParentId());
        childItem.setEditId(this._note.getCurrentEditId());

        var sequence = entry.getListeditor() ? entry.getListeditor().numEntries() : 0;
        childItem.setSequence(sequence);

        _parent.getChildrenSet().saveItem(childItem, false, {
            successCb: function() { that._widget.addEntryChild(entry, childItem, doHighlight); }
        });
    }
};

el8.appchart.visitNote.section.prototype.highlightEntryChild = function(index, childIndex) {
    if (!this._widget || !this.isMultilist()) { return; }
    this._widget.highlightEntryChild(index, childIndex);
};

el8.appchart.visitNote.section.prototype.saveIfDirty = function() {
    if (!this._widget || this.isTextlist()) { return; }
    this._widget.saveIfDirty(); // multilist, textarea or listeditor
};

el8.appchart.visitNote.section.prototype.isItemReferenced = function(id) {
    return Boolean(this._referencedItems[id]);
};

el8.appchart.visitNote.section.prototype.isMultilist = function() {
    return this._type === 'multilist';
};

el8.appchart.visitNote.section.prototype.isTextlist = function() {
    return this._type === 'textlist';
};

el8.appchart.visitNote.section.prototype.hasReferencedItems = function() {
    return this._type !== 'textarea';
};

el8.appchart.visitNote.section.prototype.hasOwnedDocs = function() {
    return (this._type === 'textlist') || (this._type === 'textlisteditor') ||
        (this._type === 'textmultilist');
};

el8.appchart.visitNote.section.prototype.getName = function() {
    return this._name;
};

el8.appchart.visitNote.section.prototype.show = function() {
    if (this.isTextlist()) { return; } /* textlists control their own show/hide */
    if (this._container.is(':hidden')) {
        if (this._showTrigger) { this._showTrigger.hide(); }
        this._container.show();
        this._infoField.getInputField().focusFocus();
    }
};

el8.appchart.visitNote.section.prototype.hide = function() {
    if (this.isTextlist()) { return; } /* textlists control their own show/hide */
    if (!this._container.is(':hidden')) {
        if (this._showTrigger) { this._showTrigger.show(); }
        this._container.hide();
    }
};

el8.appchart.visitNote.section.prototype.getType = function() {
    return this._type;
};

el8.appchart.visitNote.section.prototype.getMultilistEntries = function() {
    if (this.isMultilist()) {
        return this._widget.getEntryObjs();
    }
};

el8.appchart.visitNote.section.prototype.removeOwnedDoc = function(docId) {
    if (this.hasOwnedDocs()) {
        this._widget.removeOwnedDoc(docId);
    }
};

// Returns an array of section widget data, used for VisitNoteTemplate serialization
el8.appchart.visitNote.section.prototype.getJsonData = function() {
    if (typeof(this._widget.getJsonData) !== 'undefined') {
        return this._widget.getJsonData();
    }
};
